import React from 'react';
import {MasterLayout} from 'layout';
import {ChinhSuaCuocThanhTra} from 'modules/thanh-tra';

export default class ThayTheCuocThanhTraPage extends React.Component {
 
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <ChinhSuaCuocThanhTra check={this.props.location} params={this.props.params} type='KE_HOACH'/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/thanh-tra/ThayTheCuocThanhTraPage.jsx